import * as Types from '../types-hasura.generated';

import { ClientError } from "graphql-request";
import { CollectionFragmentExtended } from '../hasura-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { hasuraFetcher } from 'lib/clients/hasura-client';
export type CollectionByUuidVariables = Types.Exact<{
  id: Types.Scalars['uuid'];
}>;


export type CollectionByUuid = { collections: Array<(
    Pick<Types.Collection, 'chainId' | 'collectionImageUrl' | 'contractAddress' | 'slug' | 'coverImageUrl' | 'createdAt' | 'creatorAddress' | 'description' | 'id' | 'name' | 'symbol' | 'updatedAt' | 'contractType' | 'moderationStatus' | 'moderationFrom' | 'hiddenAt' | 'deletedAt' | 'baseURI' | 'maxTokenId' | 'isRevealed' | 'brandColor'>
    & { creator: Pick<Types.User, 'bio' | 'coverImageUrl' | 'createdAt' | 'isAdmin' | 'links' | 'moderationStatus' | 'name' | 'profileImageUrl' | 'publicKey' | 'username'>, splits: Array<(
      Pick<Types.Split_Recipient, 'id' | 'contractAddress' | 'indexOfShare' | 'publicKey' | 'sharePercent'>
      & { user: Pick<Types.User, 'name' | 'profileImageUrl' | 'publicKey' | 'username'> }
    )> }
  )> };



export const CollectionByUuidDocument = /*#__PURE__*/ `
    query CollectionByUuid($id: uuid!) {
  collections: collection(where: {id: {_eq: $id}}) {
    ...CollectionFragmentExtended
  }
}
    ${CollectionFragmentExtended}`;

export const useCollectionByUuid = <
      TData = CollectionByUuid,
      TError = ClientError
    >(
      variables: CollectionByUuidVariables,
      options?: Omit<UseQueryOptions<CollectionByUuid, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CollectionByUuid, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CollectionByUuid, TError, TData>(
      {
    queryKey: ['CollectionByUuid', variables],
    queryFn: hasuraFetcher<CollectionByUuid, CollectionByUuidVariables>(CollectionByUuidDocument, variables),
    ...options
  }
    )};

useCollectionByUuid.getKey = (variables: CollectionByUuidVariables) => ['CollectionByUuid', variables];

export const useInfiniteCollectionByUuid = <
      TData = InfiniteData<CollectionByUuid>,
      TError = ClientError
    >(
      variables: CollectionByUuidVariables,
      options: Omit<UseInfiniteQueryOptions<CollectionByUuid, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CollectionByUuid, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CollectionByUuid, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CollectionByUuid.infinite', variables],
      queryFn: (metaData) => hasuraFetcher<CollectionByUuid, CollectionByUuidVariables>(CollectionByUuidDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCollectionByUuid.getKey = (variables: CollectionByUuidVariables) => ['CollectionByUuid.infinite', variables];


useCollectionByUuid.fetcher = (variables: CollectionByUuidVariables, options?: RequestInit['headers']) => hasuraFetcher<CollectionByUuid, CollectionByUuidVariables>(CollectionByUuidDocument, variables, options);
